// ================================================
// Dictionnaire de traductions (FR / EN / NL)
// ================================================

const translations = {
  fr: {
    // ===== Navigation =====
    "nav.spectacles": "Spectacles",
    "nav.artists": "Artistes",
    "nav.reservations": "Mes Réservations",
    "nav.adminDashboard": "Tableau de bord",
    "nav.producerDashboard": "Espace Producteur",
    "nav.login": "Connexion",
    "nav.register": "Inscription",
    "nav.logout": "Déconnexion",

    // ===== Footer =====
    "footer.copyright": "Copyright",
    "footer.legal": "Mentions légales",
    "footer.rss": "RSS",

    // ===== Communs =====
    "common.cancel": "Annuler",
    "common.save": "Enregistrer",
    "common.delete": "Supprimer",
    "common.back": "Retour",
    "common.share": "Partager",
    "common.loading": "Chargement...",
    "common.confirm": "Confirmer",
    "common.required": "obligatoire",
    "common.optional": "optionnel",
    "common.search": "Rechercher",
    "common.email": "Email",
    "common.password": "Mot de passe",

    // ===== Roles =====
    "role.admin": "Administrateur",
    "role.producer": "Producteur",
    "role.user": "Utilisateur",

    // ===== Validation =====
    "valid.checking": "Vérification...",
    "valid.required": "Obligatoire",
    "valid.minChars": "Au moins 3 caractères",
    "valid.passwordMin": "Au moins 6 caractères",
    "valid.passwordUpper": "Au moins une majuscule",
    "valid.passwordSpecial": "Au moins un caractère spécial",
    "valid.passwordValid": "Mot de passe valide",
    "valid.passwordNewValid": "Nouveau mot de passe valide",
    "valid.passwordsMatch": "Les mots de passe correspondent",
    "valid.passwordsNoMatch": "Les mots de passe ne correspondent pas",
    "valid.confirmRequired": "Confirmation requise",
    "valid.emailFormat": "Format email invalide",
    "valid.emailAvailable": "Email disponible",
    "valid.emailTaken": "Email déjà utilisé",
    "valid.loginAvailable": "Login disponible",
    "valid.loginTaken": "Login déjà pris",
    "valid.checkImpossible": "Vérification impossible",
    "valid.allFieldsRequired": "Tous les champs doivent être valides pour activer le bouton",

    // ===== Auth — Login =====
    "login.title": "Connexion",
    "login.subtitle": "Connectez-vous à votre compte.",
    "login.credentials": "Identifiants",
    "login.submit": "Se connecter",
    "login.loading": "Connexion...",
    "login.forgot": "Mot de passe oublié ?",
    "login.noAccount": "Pas encore de compte ?",
    "login.signUp": "S'inscrire",
    "login.emailPlaceholder": "votre@email.com",
    "login.emailPwdRequired": "Email et mot de passe obligatoires.",
    "login.invalid": "Email ou mot de passe incorrect",

    // ===== Auth — Register =====
    "register.title": "Inscription",
    "register.subtitle": "Créez votre compte.",
    "register.credentials": "Identifiants",
    "register.personal": "Informations personnelles",
    "register.security": "Sécurité",
    "register.login": "Login",
    "register.loginPlaceholder": "ex: jean.dupont",
    "register.email": "Email",
    "register.emailPlaceholder": "votre@email.com",
    "register.firstName": "Prénom",
    "register.lastName": "Nom",
    "register.language": "Langue",
    "register.password": "Mot de passe",
    "register.passwordConfirm": "Confirmer le mot de passe",
    "register.passwordHint": "Min 6 caractères, au moins une majuscule et un caractère spécial",
    "register.submit": "S'inscrire",
    "register.loading": "Inscription...",
    "register.hasAccount": "Déjà un compte ?",
    "register.signIn": "Se connecter",
    "register.organization": "Vous êtes une organisation ?",
    "register.producerSignup": "Inscription producteur",

    // ===== Auth — RegisterProducteur =====
    "producer.title": "Inscription Producteur",
    "producer.subtitle": "Demandez l'accès à votre espace producteur.",
    "producer.space": "Espace producteur",
    "producer.accountTitle": "Compte producteur",
    "producer.accountDesc": "Le compte producteur vous permet de créer vos propres spectacles, suivre les statistiques (réservations, revenus, taux de remplissage) et modérer les commentaires de votre catalogue. Votre demande sera validée par un administrateur.",
    "producer.proEmail": "Email professionnel",
    "producer.proEmailPlaceholder": "contact@maboite.com",
    "producer.loginPlaceholder": "ex: ma.boite",
    "producer.submit": "Demander un compte producteur",
    "producer.loading": "Envoi de la demande...",
    "producer.standardAccount": "Compte standard ?",
    "producer.userSignup": "Inscription utilisateur",

    // ===== Auth — Forgot Password =====
    "forgot.title": "Mot de passe oublié",
    "forgot.subtitle": "Recevez un lien de réinitialisation par email.",
    "forgot.section": "Réinitialisation",
    "forgot.intro": "Entrez l'adresse email de votre compte. Nous vous enverrons un lien pour choisir un nouveau mot de passe.",
    "forgot.submit": "Envoyer le lien",
    "forgot.loading": "Envoi...",
    "forgot.back": "Retour à la connexion",
    "forgot.emailRequired": "Veuillez saisir votre email.",
    "forgot.success": "Si cette adresse est connue, un email de réinitialisation a été envoyé.",

    // ===== Auth — Reset Password =====
    "reset.title": "Nouveau mot de passe",
    "reset.subtitle": "Choisissez un nouveau mot de passe sécurisé.",
    "reset.section": "Nouveau mot de passe",
    "reset.newPassword": "Nouveau mot de passe",
    "reset.confirmPassword": "Confirmer le mot de passe",
    "reset.submit": "Valider le nouveau mot de passe",
    "reset.loading": "Mise à jour...",
    "reset.back": "Retour à la connexion",
    "reset.tokenMissing": "Lien invalide : aucun token fourni.",
    "reset.bothRequired": "Les deux champs sont obligatoires.",
    "reset.minChars": "Le mot de passe doit contenir au moins 6 caractères.",
    "reset.noMatch": "Les mots de passe ne correspondent pas.",
    "reset.success": "Mot de passe réinitialisé avec succès.",
    "reset.redirecting": "Redirection vers la connexion...",

    // ===== Profile =====
    "profile.firstName": "Prénom",
    "profile.lastName": "Nom",
    "profile.role": "Rôle",
    "profile.language": "Langue",
    "profile.email": "Email",
    "profile.info": "Informations",
    "profile.edit": "Modifier mon profil",
    "profile.delete": "Supprimer mon compte",
    "profile.deleting": "Suppression...",
    "profile.deleteConfirm": "Êtes-vous sûr de vouloir supprimer votre compte ?\n\nCette action est IRRÉVERSIBLE. Toutes vos données (réservations, commentaires, etc.) seront définitivement perdues.",
    "profile.deletePrompt": "Pour confirmer, tapez SUPPRIMER en majuscules :",
    "profile.deleteCancelled": "Suppression annulée.",

    // ===== ProfileEdit =====
    "profileEdit.title": "Modifier mon profil",
    "profileEdit.subtitle": "Mettez à jour vos informations personnelles.",
    "profileEdit.changePassword": "Changer le mot de passe",
    "profileEdit.newPassword": "Nouveau mot de passe",
    "profileEdit.newPasswordHint": "(laisser vide pour ne pas changer)",
    "profileEdit.confirmNewPassword": "Confirmer le nouveau mot de passe",
    "profileEdit.save": "Sauvegarder",
    "profileEdit.saving": "Sauvegarde...",
    "profileEdit.cancel": "Annuler",

    // ===== Spectacles List =====
    "spectacles.title": "Nos Spectacles",
    "spectacles.subtitle": "Découvrez et réservez vos spectacles",
    "spectacles.count": "spectacle",
    "spectacles.countPlural": "spectacles",
    "spectacles.newButton": "Nouveau spectacle",
    "spectacles.searchLabel": "Rechercher",
    "spectacles.searchPlaceholder": "Titre ou description...",
    "spectacles.sortBy": "Trier par",
    "spectacles.sortDate": "Date",
    "spectacles.sortPrice": "Prix",
    "spectacles.sortName": "Nom",
    "spectacles.order": "Ordre",
    "spectacles.asc": "Ascendant",
    "spectacles.desc": "Descendant",
    "spectacles.location": "Lieu",
    "spectacles.allLocations": "Tous les lieux",
    "spectacles.view": "Voir",
    "spectacles.empty": "Aucun spectacle ne correspond à votre recherche.",
    "spectacles.page": "Page",
    "spectacles.pageOf": "sur",

    // ===== Spectacle Detail =====
    "detail.info": "Informations",
    "detail.title": "Titre",
    "detail.date": "Date",
    "detail.location": "Lieu",
    "detail.price": "Prix",
    "detail.artist": "Artiste",
    "detail.notSet": "Non renseigné",
    "detail.description": "Description",
    "detail.noDescription": "Aucune description disponible.",
    "detail.representations": "Représentations disponibles",
    "detail.addRepresentation": "Ajouter une représentation",
    "detail.noRepresentations": "Aucune représentation disponible.",
    "detail.dateTime": "Date et heure",
    "detail.placesAvailable": "Places disponibles",
    "detail.full": "Complet",
    "detail.book": "Réserver",
    "detail.confirmBooking": "Confirmer la réservation",
    "detail.numPlaces": "Nombre de places",
    "detail.total": "Total",
    "detail.confirm": "Confirmer",
    "detail.booking": "Réservation...",
    "detail.connectToBook": "Connectez-vous pour réserver !",
    "detail.invalidPlaces": "Nombre de places invalide.",
    "detail.modify": "Modifier",
    "detail.spectatorReviews": "Avis des spectateurs",
    "detail.places": "places",

    // ===== Comments =====
    "comments.translateTo": "Traduire les avis vers :",
    "comments.review": "avis",
    "comments.edit": "Modifier mon avis",
    "comments.leave": "Laisser un avis",
    "comments.connectToComment": "Se connecter pour commenter",
    "comments.yourRating": "Votre note",
    "comments.yourReview": "Votre avis",
    "comments.shareExp": "Partagez votre expérience...",
    "comments.publish": "Publier",
    "comments.update": "Mettre à jour",
    "comments.sending": "Envoi...",
    "comments.empty": "Aucun avis pour le moment. Soyez le premier !",
    "comments.modified": "(modifié)",
    "comments.delete": "Supprimer",
    "comments.deleteConfirm": "Supprimer ce commentaire ?",
    "comments.translate": "Traduire",
    "comments.translating": "Traduction...",
    "comments.hide": "Masquer la traduction",
    "comments.translation": "Traduction",
    "comments.detected": "détecté",
    "comments.via": "via",
    "comments.contentRequired": "Le commentaire ne peut pas être vide.",

    // ===== Reservations =====
    "reservations.title": "Mes Réservations",
    "reservations.subtitle": "Consultez vos réservations",
    "reservations.empty": "Vous n'avez aucune réservation.",
    "reservations.spectacle": "Spectacle",
    "reservations.date": "Date",
    "reservations.places": "Places",
    "reservations.status": "Statut",
    "reservations.actions": "Actions",
    "reservations.pay": "Payer",
    "reservations.cancel": "Annuler",
    "reservations.cancelConfirm": "Annuler cette réservation ?",
    "reservations.statusCreated": "En attente de paiement",
    "reservations.statusConfirmed": "Confirmée",
    "reservations.statusCancelled": "Annulée",

    // ===== Payment =====
    "payment.title": "Paiement",
    "payment.summary": "Récapitulatif de votre commande",
    "payment.spectacle": "Spectacle",
    "payment.totalToPay": "Total à payer",
    "payment.stripeInfo": "Vous allez être redirigé vers Stripe",
    "payment.stripeDesc": "Sur la page suivante, vous pourrez choisir votre méthode de paiement (carte bancaire, Bancontact, iDEAL, etc.) selon ce qui est disponible dans votre région.",
    "payment.payWith": "Payer {amount} EUR avec Stripe",
    "payment.redirecting": "Redirection vers Stripe...",
    "payment.cancel": "Annuler",
    "payment.preparing": "Préparation du paiement...",
    "payment.testMode": "Mode test Stripe",
    "payment.testCard": "Carte",
    "payment.otherMethods": "Autres méthodes (Bancontact, iDEAL, etc.) : sélectionner et cliquer Payer.",
    "payment.urlMissing": "URL de paiement manquante. Rafraîchissez la page.",
    "payment.choose": "Choisissez votre méthode de paiement",
    "payment.cannotLoad": "Impossible de charger le paiement: ",

    // ===== Payment Success =====
    "paySuccess.titleLoading": "Confirmation...",
    "paySuccess.titleError": "Erreur de paiement",
    "paySuccess.titleSuccess": "Paiement confirmé",
    "paySuccess.subtitle": "Merci pour votre réservation",
    "paySuccess.verifying": "Vérification du paiement...",
    "paySuccess.verifyingDesc": "Nous validons votre transaction avec Stripe.",
    "paySuccess.errorTitle": "Erreur de confirmation",
    "paySuccess.successTitle": "Paiement réussi !",
    "paySuccess.successDesc": "Votre réservation a bien été confirmée.",
    "paySuccess.paidWith": "Payé par",
    "paySuccess.receiptSent": "Un reçu a été envoyé à votre adresse email.",
    "paySuccess.myReservations": "Mes réservations",
    "paySuccess.home": "Accueil",
    "paySuccess.sessionMissing": "Identifiant de session Stripe manquant.",
    "paySuccess.confirmFailed": "Confirmation échouée.",

    // ===== Payment Cancel =====
    "payCancel.title": "Paiement annulé",
    "payCancel.subtitle": "Aucun montant n'a été débité",
    "payCancel.message": "Vous avez annulé la transaction. Aucun montant n'a été prélevé.",
    "payCancel.bookingPending": "Votre réservation reste en attente. Vous pouvez relancer le paiement quand vous le souhaitez depuis votre espace.",
    "payCancel.retry": "Réessayer le paiement",
    "payCancel.myReservations": "Mes réservations",

    // ===== Cookie Banner =====
    "cookie.title": "Respect de votre vie privée",
    "cookie.text": "Nous utilisons des cookies techniques essentiels au fonctionnement du site (session, authentification) et, avec votre accord, des cookies de mesure d'audience.",
    "cookie.learnMore": "En savoir plus",
    "cookie.reject": "Refuser",
    "cookie.accept": "Tout accepter",

    // ===== Mentions Légales =====
    "legal.title": "Mentions légales & Confidentialité",
    "legal.subtitle": "Vos droits et nos obligations",
    "legal.legalNotice": "Mentions légales",
    "legal.editor": "Éditeur du site",
    "legal.editorDesc": "PID Réservations — Projet académique réalisé dans le cadre du cours de Projet Intégré (ICC).",
    "legal.contact": "Contact",
    "legal.hosting": "Hébergement",
    "legal.hostingDesc": "Hébergé sur un VPS Hetzner Cloud (Ubuntu 24.04, Helsinki) — Conteneurs Docker (nginx + Spring Boot + MySQL) — HTTPS via Let's Encrypt — Domaine artistdb-icc.duckdns.org.",
    "legal.tech": "Technologies",
    "legal.techDesc": "React 19, Spring Boot 3, MySQL, Stripe (paiements), Mailtrap (emails de test).",
    "legal.privacy": "Politique de confidentialité (RGPD)",
    "legal.dataCollected": "Données collectées",
    "legal.dataCollectedDesc": "Lors de votre inscription, nous collectons : votre nom, prénom, email et un mot de passe (stocké chiffré avec BCrypt). Lors d'une réservation, nous conservons l'historique de vos achats pour vous permettre d'y accéder dans votre espace personnel.",
    "legal.purpose": "Finalité",
    "legal.purposeDesc": "Vos données servent uniquement à fournir le service de réservation : authentification, achat de billets, envoi d'emails de confirmation et de réinitialisation de mot de passe. Aucune donnée n'est revendue à des tiers.",
    "legal.retention": "Durée de conservation",
    "legal.retentionDesc": "Vos données sont conservées tant que votre compte est actif. À la suppression de votre compte, vos données personnelles sont effacées dans un délai de 30 jours (les réservations historiques sont anonymisées pour la comptabilité).",
    "legal.rights": "Vos droits",
    "legal.rightsDesc": "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité de vos données. Pour exercer ces droits, contactez-nous à",
    "legal.cookies": "Cookies",
    "legal.cookiesYourChoice": "Votre choix actuel",
    "legal.cookiesOptional": "Cookies optionnels",
    "legal.cookiesAccepted": "Acceptés",
    "legal.cookiesRejected": "Refusés",
    "legal.cookiesNotChosen": "Non choisi",
    "legal.cookiesAccept": "Accepter",
    "legal.cookiesReject": "Refuser",
    "legal.cookiesReset": "Réinitialiser",
    "legal.cookiesTechnical": "Cookies techniques (obligatoires)",
    "legal.cookiesTechnicalDesc": "Le site utilise localStorage pour conserver votre token JWT (session de connexion) et votre profil utilisateur (prénom, nom, rôle). Ces données sont indispensables au fonctionnement et ne nécessitent pas votre consentement.",
    "legal.cookiesOptionalDesc": "Aucun cookie de tracking tiers (Google Analytics, Facebook Pixel, etc.) n'est actuellement utilisé. Le bandeau de consentement vous permettra d'accepter ou refuser ces cookies si nous en ajoutons à l'avenir.",
    "legal.payments": "Paiements sécurisés",
    "legal.paymentsDesc": "Les paiements sont traités par Stripe. Aucune donnée bancaire n'est stockée sur nos serveurs : le numéro de carte est saisi directement dans un formulaire sécurisé hébergé par Stripe (norme PCI-DSS).",
  },

  en: {
    "nav.spectacles": "Shows",
    "nav.artists": "Artists",
    "nav.reservations": "My Bookings",
    "nav.adminDashboard": "Dashboard",
    "nav.producerDashboard": "Producer Space",
    "nav.login": "Sign in",
    "nav.register": "Sign up",
    "nav.logout": "Logout",

    "footer.copyright": "Copyright",
    "footer.legal": "Legal notice",
    "footer.rss": "RSS",

    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.delete": "Delete",
    "common.back": "Back",
    "common.share": "Share",
    "common.loading": "Loading...",
    "common.confirm": "Confirm",
    "common.required": "required",
    "common.optional": "optional",
    "common.search": "Search",
    "common.email": "Email",
    "common.password": "Password",

    "role.admin": "Administrator",
    "role.producer": "Producer",
    "role.user": "User",

    "valid.checking": "Checking...",
    "valid.required": "Required",
    "valid.minChars": "At least 3 characters",
    "valid.passwordMin": "At least 6 characters",
    "valid.passwordUpper": "At least one uppercase letter",
    "valid.passwordSpecial": "At least one special character",
    "valid.passwordValid": "Valid password",
    "valid.passwordNewValid": "Valid new password",
    "valid.passwordsMatch": "Passwords match",
    "valid.passwordsNoMatch": "Passwords do not match",
    "valid.confirmRequired": "Confirmation required",
    "valid.emailFormat": "Invalid email format",
    "valid.emailAvailable": "Email available",
    "valid.emailTaken": "Email already used",
    "valid.loginAvailable": "Login available",
    "valid.loginTaken": "Login already taken",
    "valid.checkImpossible": "Check failed",
    "valid.allFieldsRequired": "All fields must be valid to enable the button",

    "login.title": "Sign in",
    "login.subtitle": "Sign in to your account.",
    "login.credentials": "Credentials",
    "login.submit": "Sign in",
    "login.loading": "Signing in...",
    "login.forgot": "Forgot password?",
    "login.noAccount": "No account yet?",
    "login.signUp": "Sign up",
    "login.emailPlaceholder": "your@email.com",
    "login.emailPwdRequired": "Email and password required.",
    "login.invalid": "Invalid email or password",

    "register.title": "Sign up",
    "register.subtitle": "Create your account.",
    "register.credentials": "Credentials",
    "register.personal": "Personal information",
    "register.security": "Security",
    "register.login": "Login",
    "register.loginPlaceholder": "e.g. john.doe",
    "register.email": "Email",
    "register.emailPlaceholder": "your@email.com",
    "register.firstName": "First name",
    "register.lastName": "Last name",
    "register.language": "Language",
    "register.password": "Password",
    "register.passwordConfirm": "Confirm password",
    "register.passwordHint": "Min 6 characters, at least one uppercase letter and one special character",
    "register.submit": "Sign up",
    "register.loading": "Signing up...",
    "register.hasAccount": "Already have an account?",
    "register.signIn": "Sign in",
    "register.organization": "Are you an organization?",
    "register.producerSignup": "Producer sign up",

    "producer.title": "Producer Sign up",
    "producer.subtitle": "Request access to your producer space.",
    "producer.space": "Producer space",
    "producer.accountTitle": "Producer account",
    "producer.accountDesc": "A producer account lets you create your own shows, monitor statistics (bookings, revenue, fill rate) and moderate comments on your catalog. Your request will be validated by an administrator.",
    "producer.proEmail": "Business email",
    "producer.proEmailPlaceholder": "contact@mycompany.com",
    "producer.loginPlaceholder": "e.g. my.company",
    "producer.submit": "Request a producer account",
    "producer.loading": "Sending request...",
    "producer.standardAccount": "Standard account?",
    "producer.userSignup": "User sign up",

    "forgot.title": "Forgot password",
    "forgot.subtitle": "Receive a reset link by email.",
    "forgot.section": "Reset",
    "forgot.intro": "Enter your account email. We will send you a link to choose a new password.",
    "forgot.submit": "Send link",
    "forgot.loading": "Sending...",
    "forgot.back": "Back to sign in",
    "forgot.emailRequired": "Please enter your email.",
    "forgot.success": "If this address exists, a reset email has been sent.",

    "reset.title": "New password",
    "reset.subtitle": "Choose a new secure password.",
    "reset.section": "New password",
    "reset.newPassword": "New password",
    "reset.confirmPassword": "Confirm password",
    "reset.submit": "Set new password",
    "reset.loading": "Updating...",
    "reset.back": "Back to sign in",
    "reset.tokenMissing": "Invalid link: no token provided.",
    "reset.bothRequired": "Both fields are required.",
    "reset.minChars": "Password must contain at least 6 characters.",
    "reset.noMatch": "Passwords do not match.",
    "reset.success": "Password successfully reset.",
    "reset.redirecting": "Redirecting to sign in...",

    "profile.firstName": "First name",
    "profile.lastName": "Last name",
    "profile.role": "Role",
    "profile.language": "Language",
    "profile.email": "Email",
    "profile.info": "Information",
    "profile.edit": "Edit my profile",
    "profile.delete": "Delete my account",
    "profile.deleting": "Deleting...",
    "profile.deleteConfirm": "Are you sure you want to delete your account?\n\nThis action is IRREVERSIBLE. All your data (bookings, comments, etc.) will be permanently lost.",
    "profile.deletePrompt": "To confirm, type DELETE in uppercase:",
    "profile.deleteCancelled": "Deletion cancelled.",

    "profileEdit.title": "Edit my profile",
    "profileEdit.subtitle": "Update your personal information.",
    "profileEdit.changePassword": "Change password",
    "profileEdit.newPassword": "New password",
    "profileEdit.newPasswordHint": "(leave empty to keep unchanged)",
    "profileEdit.confirmNewPassword": "Confirm new password",
    "profileEdit.save": "Save",
    "profileEdit.saving": "Saving...",
    "profileEdit.cancel": "Cancel",

    "spectacles.title": "Our Shows",
    "spectacles.subtitle": "Discover and book your shows",
    "spectacles.count": "show",
    "spectacles.countPlural": "shows",
    "spectacles.newButton": "New show",
    "spectacles.searchLabel": "Search",
    "spectacles.searchPlaceholder": "Title or description...",
    "spectacles.sortBy": "Sort by",
    "spectacles.sortDate": "Date",
    "spectacles.sortPrice": "Price",
    "spectacles.sortName": "Name",
    "spectacles.order": "Order",
    "spectacles.asc": "Ascending",
    "spectacles.desc": "Descending",
    "spectacles.location": "Location",
    "spectacles.allLocations": "All locations",
    "spectacles.view": "View",
    "spectacles.empty": "No show matches your search.",
    "spectacles.page": "Page",
    "spectacles.pageOf": "of",

    "detail.info": "Information",
    "detail.title": "Title",
    "detail.date": "Date",
    "detail.location": "Location",
    "detail.price": "Price",
    "detail.artist": "Artist",
    "detail.notSet": "Not set",
    "detail.description": "Description",
    "detail.noDescription": "No description available.",
    "detail.representations": "Available performances",
    "detail.addRepresentation": "Add a performance",
    "detail.noRepresentations": "No performance available.",
    "detail.dateTime": "Date and time",
    "detail.placesAvailable": "Seats available",
    "detail.full": "Sold out",
    "detail.book": "Book",
    "detail.confirmBooking": "Confirm booking",
    "detail.numPlaces": "Number of seats",
    "detail.total": "Total",
    "detail.confirm": "Confirm",
    "detail.booking": "Booking...",
    "detail.connectToBook": "Sign in to book!",
    "detail.invalidPlaces": "Invalid number of seats.",
    "detail.modify": "Edit",
    "detail.spectatorReviews": "Spectator reviews",
    "detail.places": "seats",

    "comments.translateTo": "Translate reviews to:",
    "comments.review": "review",
    "comments.edit": "Edit my review",
    "comments.leave": "Leave a review",
    "comments.connectToComment": "Sign in to comment",
    "comments.yourRating": "Your rating",
    "comments.yourReview": "Your review",
    "comments.shareExp": "Share your experience...",
    "comments.publish": "Publish",
    "comments.update": "Update",
    "comments.sending": "Sending...",
    "comments.empty": "No reviews yet. Be the first!",
    "comments.modified": "(edited)",
    "comments.delete": "Delete",
    "comments.deleteConfirm": "Delete this comment?",
    "comments.translate": "Translate",
    "comments.translating": "Translating...",
    "comments.hide": "Hide translation",
    "comments.translation": "Translation",
    "comments.detected": "detected",
    "comments.via": "via",
    "comments.contentRequired": "The comment cannot be empty.",

    "reservations.title": "My Bookings",
    "reservations.subtitle": "View your bookings",
    "reservations.empty": "You have no bookings.",
    "reservations.spectacle": "Show",
    "reservations.date": "Date",
    "reservations.places": "Seats",
    "reservations.status": "Status",
    "reservations.actions": "Actions",
    "reservations.pay": "Pay",
    "reservations.cancel": "Cancel",
    "reservations.cancelConfirm": "Cancel this booking?",
    "reservations.statusCreated": "Awaiting payment",
    "reservations.statusConfirmed": "Confirmed",
    "reservations.statusCancelled": "Cancelled",

    "payment.title": "Payment",
    "payment.summary": "Order summary",
    "payment.spectacle": "Show",
    "payment.totalToPay": "Total to pay",
    "payment.stripeInfo": "You will be redirected to Stripe",
    "payment.stripeDesc": "On the next page you can choose your payment method (credit card, Bancontact, iDEAL, etc.) depending on what's available in your region.",
    "payment.payWith": "Pay {amount} EUR with Stripe",
    "payment.redirecting": "Redirecting to Stripe...",
    "payment.cancel": "Cancel",
    "payment.preparing": "Preparing payment...",
    "payment.testMode": "Stripe test mode",
    "payment.testCard": "Card",
    "payment.otherMethods": "Other methods (Bancontact, iDEAL, etc.): select and click Pay.",
    "payment.urlMissing": "Payment URL missing. Refresh the page.",
    "payment.choose": "Choose your payment method",
    "payment.cannotLoad": "Cannot load payment: ",

    "paySuccess.titleLoading": "Confirming...",
    "paySuccess.titleError": "Payment error",
    "paySuccess.titleSuccess": "Payment confirmed",
    "paySuccess.subtitle": "Thanks for your booking",
    "paySuccess.verifying": "Verifying payment...",
    "paySuccess.verifyingDesc": "We are validating your transaction with Stripe.",
    "paySuccess.errorTitle": "Confirmation error",
    "paySuccess.successTitle": "Payment successful!",
    "paySuccess.successDesc": "Your booking has been confirmed.",
    "paySuccess.paidWith": "Paid by",
    "paySuccess.receiptSent": "A receipt has been sent to your email.",
    "paySuccess.myReservations": "My bookings",
    "paySuccess.home": "Home",
    "paySuccess.sessionMissing": "Stripe session ID missing.",
    "paySuccess.confirmFailed": "Confirmation failed.",

    "payCancel.title": "Payment cancelled",
    "payCancel.subtitle": "No amount has been charged",
    "payCancel.message": "You cancelled the transaction. No amount has been charged.",
    "payCancel.bookingPending": "Your booking is still pending. You can resume the payment anytime from your space.",
    "payCancel.retry": "Retry payment",
    "payCancel.myReservations": "My bookings",

    "cookie.title": "Privacy notice",
    "cookie.text": "We use essential technical cookies for the site to work (session, authentication) and, with your consent, audience measurement cookies.",
    "cookie.learnMore": "Learn more",
    "cookie.reject": "Reject",
    "cookie.accept": "Accept all",

    "legal.title": "Legal notice & Privacy",
    "legal.subtitle": "Your rights and our obligations",
    "legal.legalNotice": "Legal notice",
    "legal.editor": "Site editor",
    "legal.editorDesc": "PID Réservations — Academic project for the Integrated Project course (ICC).",
    "legal.contact": "Contact",
    "legal.hosting": "Hosting",
    "legal.hostingDesc": "Hosted on a Hetzner Cloud VPS (Ubuntu 24.04, Helsinki) — Docker containers (nginx + Spring Boot + MySQL) — HTTPS via Let's Encrypt — Domain artistdb-icc.duckdns.org.",
    "legal.tech": "Technologies",
    "legal.techDesc": "React 19, Spring Boot 3, MySQL, Stripe (payments), Mailtrap (test emails).",
    "legal.privacy": "Privacy policy (GDPR)",
    "legal.dataCollected": "Data collected",
    "legal.dataCollectedDesc": "When signing up we collect: your first name, last name, email and password (stored hashed with BCrypt). When booking we keep the history of your purchases so you can access them in your personal space.",
    "legal.purpose": "Purpose",
    "legal.purposeDesc": "Your data is only used to provide the booking service: authentication, ticket purchase, confirmation and password reset emails. No data is sold to third parties.",
    "legal.retention": "Retention period",
    "legal.retentionDesc": "Your data is kept as long as your account is active. When you delete your account, your personal data is erased within 30 days (historical bookings are anonymized for accounting purposes).",
    "legal.rights": "Your rights",
    "legal.rightsDesc": "Under GDPR you have rights to access, rectification, deletion and portability of your data. To exercise these rights, contact us at",
    "legal.cookies": "Cookies",
    "legal.cookiesYourChoice": "Your current choice",
    "legal.cookiesOptional": "Optional cookies",
    "legal.cookiesAccepted": "Accepted",
    "legal.cookiesRejected": "Rejected",
    "legal.cookiesNotChosen": "Not chosen",
    "legal.cookiesAccept": "Accept",
    "legal.cookiesReject": "Reject",
    "legal.cookiesReset": "Reset",
    "legal.cookiesTechnical": "Technical cookies (mandatory)",
    "legal.cookiesTechnicalDesc": "The site uses localStorage to keep your JWT token (login session) and your user profile (first name, last name, role). This data is essential for the site to work and does not require your consent.",
    "legal.cookiesOptionalDesc": "No third-party tracking cookies (Google Analytics, Facebook Pixel, etc.) are currently used. The consent banner will let you accept or refuse these cookies if we add them in the future.",
    "legal.payments": "Secure payments",
    "legal.paymentsDesc": "Payments are processed by Stripe. No banking data is stored on our servers: the card number is entered directly in a secure form hosted by Stripe (PCI-DSS standard).",
  },

  nl: {
    "nav.spectacles": "Voorstellingen",
    "nav.artists": "Artiesten",
    "nav.reservations": "Mijn Reserveringen",
    "nav.adminDashboard": "Dashboard",
    "nav.producerDashboard": "Producer Ruimte",
    "nav.login": "Inloggen",
    "nav.register": "Registreren",
    "nav.logout": "Uitloggen",

    "footer.copyright": "Copyright",
    "footer.legal": "Juridische kennisgeving",
    "footer.rss": "RSS",

    "common.cancel": "Annuleren",
    "common.save": "Opslaan",
    "common.delete": "Verwijderen",
    "common.back": "Terug",
    "common.share": "Delen",
    "common.loading": "Laden...",
    "common.confirm": "Bevestigen",
    "common.required": "verplicht",
    "common.optional": "optioneel",
    "common.search": "Zoeken",
    "common.email": "E-mail",
    "common.password": "Wachtwoord",

    "role.admin": "Beheerder",
    "role.producer": "Producent",
    "role.user": "Gebruiker",

    "valid.checking": "Controleren...",
    "valid.required": "Verplicht",
    "valid.minChars": "Minstens 3 tekens",
    "valid.passwordMin": "Minstens 6 tekens",
    "valid.passwordUpper": "Minstens één hoofdletter",
    "valid.passwordSpecial": "Minstens één speciaal teken",
    "valid.passwordValid": "Geldig wachtwoord",
    "valid.passwordNewValid": "Geldig nieuw wachtwoord",
    "valid.passwordsMatch": "Wachtwoorden komen overeen",
    "valid.passwordsNoMatch": "Wachtwoorden komen niet overeen",
    "valid.confirmRequired": "Bevestiging vereist",
    "valid.emailFormat": "Ongeldig e-mailformaat",
    "valid.emailAvailable": "E-mail beschikbaar",
    "valid.emailTaken": "E-mail al in gebruik",
    "valid.loginAvailable": "Login beschikbaar",
    "valid.loginTaken": "Login al in gebruik",
    "valid.checkImpossible": "Controle mislukt",
    "valid.allFieldsRequired": "Alle velden moeten geldig zijn om de knop te activeren",

    "login.title": "Inloggen",
    "login.subtitle": "Log in op uw account.",
    "login.credentials": "Inloggegevens",
    "login.submit": "Inloggen",
    "login.loading": "Inloggen...",
    "login.forgot": "Wachtwoord vergeten?",
    "login.noAccount": "Nog geen account?",
    "login.signUp": "Registreren",
    "login.emailPlaceholder": "uw@email.com",
    "login.emailPwdRequired": "E-mail en wachtwoord verplicht.",
    "login.invalid": "Ongeldige e-mail of wachtwoord",

    "register.title": "Registreren",
    "register.subtitle": "Maak uw account aan.",
    "register.credentials": "Inloggegevens",
    "register.personal": "Persoonlijke informatie",
    "register.security": "Beveiliging",
    "register.login": "Login",
    "register.loginPlaceholder": "bv: jan.dupont",
    "register.email": "E-mail",
    "register.emailPlaceholder": "uw@email.com",
    "register.firstName": "Voornaam",
    "register.lastName": "Achternaam",
    "register.language": "Taal",
    "register.password": "Wachtwoord",
    "register.passwordConfirm": "Wachtwoord bevestigen",
    "register.passwordHint": "Min 6 tekens, minstens één hoofdletter en één speciaal teken",
    "register.submit": "Registreren",
    "register.loading": "Registreren...",
    "register.hasAccount": "Al een account?",
    "register.signIn": "Inloggen",
    "register.organization": "Bent u een organisatie?",
    "register.producerSignup": "Producent registreren",

    "producer.title": "Producent registreren",
    "producer.subtitle": "Vraag toegang tot uw producent ruimte aan.",
    "producer.space": "Producent ruimte",
    "producer.accountTitle": "Producent account",
    "producer.accountDesc": "Met een producent account kunt u uw eigen voorstellingen maken, statistieken volgen (reserveringen, omzet, bezettingsgraad) en commentaren modereren op uw catalogus. Uw aanvraag wordt door een beheerder gevalideerd.",
    "producer.proEmail": "Zakelijke e-mail",
    "producer.proEmailPlaceholder": "contact@mijnbedrijf.com",
    "producer.loginPlaceholder": "bv: mijn.bedrijf",
    "producer.submit": "Producent account aanvragen",
    "producer.loading": "Aanvraag versturen...",
    "producer.standardAccount": "Standaard account?",
    "producer.userSignup": "Gebruiker registreren",

    "forgot.title": "Wachtwoord vergeten",
    "forgot.subtitle": "Ontvang een reset-link per e-mail.",
    "forgot.section": "Reset",
    "forgot.intro": "Voer uw account e-mail in. Wij sturen u een link om een nieuw wachtwoord te kiezen.",
    "forgot.submit": "Link versturen",
    "forgot.loading": "Versturen...",
    "forgot.back": "Terug naar inloggen",
    "forgot.emailRequired": "Voer uw e-mail in.",
    "forgot.success": "Als dit adres bekend is, is een reset e-mail verstuurd.",

    "reset.title": "Nieuw wachtwoord",
    "reset.subtitle": "Kies een nieuw beveiligd wachtwoord.",
    "reset.section": "Nieuw wachtwoord",
    "reset.newPassword": "Nieuw wachtwoord",
    "reset.confirmPassword": "Wachtwoord bevestigen",
    "reset.submit": "Nieuw wachtwoord instellen",
    "reset.loading": "Bijwerken...",
    "reset.back": "Terug naar inloggen",
    "reset.tokenMissing": "Ongeldige link: geen token.",
    "reset.bothRequired": "Beide velden zijn verplicht.",
    "reset.minChars": "Wachtwoord moet minstens 6 tekens bevatten.",
    "reset.noMatch": "Wachtwoorden komen niet overeen.",
    "reset.success": "Wachtwoord succesvol gereset.",
    "reset.redirecting": "Doorverwijzen naar inloggen...",

    "profile.firstName": "Voornaam",
    "profile.lastName": "Achternaam",
    "profile.role": "Rol",
    "profile.language": "Taal",
    "profile.email": "E-mail",
    "profile.info": "Informatie",
    "profile.edit": "Mijn profiel wijzigen",
    "profile.delete": "Mijn account verwijderen",
    "profile.deleting": "Verwijderen...",
    "profile.deleteConfirm": "Weet u zeker dat u uw account wilt verwijderen?\n\nDeze actie is ONOMKEERBAAR. Al uw gegevens (reserveringen, commentaren, enz.) gaan definitief verloren.",
    "profile.deletePrompt": "Typ ter bevestiging VERWIJDEREN in hoofdletters:",
    "profile.deleteCancelled": "Verwijdering geannuleerd.",

    "profileEdit.title": "Mijn profiel wijzigen",
    "profileEdit.subtitle": "Werk uw persoonlijke informatie bij.",
    "profileEdit.changePassword": "Wachtwoord wijzigen",
    "profileEdit.newPassword": "Nieuw wachtwoord",
    "profileEdit.newPasswordHint": "(leeg laten om niet te wijzigen)",
    "profileEdit.confirmNewPassword": "Nieuw wachtwoord bevestigen",
    "profileEdit.save": "Opslaan",
    "profileEdit.saving": "Opslaan...",
    "profileEdit.cancel": "Annuleren",

    "spectacles.title": "Onze Voorstellingen",
    "spectacles.subtitle": "Ontdek en reserveer uw voorstellingen",
    "spectacles.count": "voorstelling",
    "spectacles.countPlural": "voorstellingen",
    "spectacles.newButton": "Nieuwe voorstelling",
    "spectacles.searchLabel": "Zoeken",
    "spectacles.searchPlaceholder": "Titel of beschrijving...",
    "spectacles.sortBy": "Sorteren op",
    "spectacles.sortDate": "Datum",
    "spectacles.sortPrice": "Prijs",
    "spectacles.sortName": "Naam",
    "spectacles.order": "Volgorde",
    "spectacles.asc": "Oplopend",
    "spectacles.desc": "Aflopend",
    "spectacles.location": "Locatie",
    "spectacles.allLocations": "Alle locaties",
    "spectacles.view": "Bekijken",
    "spectacles.empty": "Geen voorstelling komt overeen met uw zoekopdracht.",
    "spectacles.page": "Pagina",
    "spectacles.pageOf": "van",

    "detail.info": "Informatie",
    "detail.title": "Titel",
    "detail.date": "Datum",
    "detail.location": "Locatie",
    "detail.price": "Prijs",
    "detail.artist": "Artiest",
    "detail.notSet": "Niet ingesteld",
    "detail.description": "Beschrijving",
    "detail.noDescription": "Geen beschrijving beschikbaar.",
    "detail.representations": "Beschikbare voorstellingen",
    "detail.addRepresentation": "Voorstelling toevoegen",
    "detail.noRepresentations": "Geen voorstelling beschikbaar.",
    "detail.dateTime": "Datum en tijd",
    "detail.placesAvailable": "Beschikbare plaatsen",
    "detail.full": "Uitverkocht",
    "detail.book": "Reserveren",
    "detail.confirmBooking": "Reservering bevestigen",
    "detail.numPlaces": "Aantal plaatsen",
    "detail.total": "Totaal",
    "detail.confirm": "Bevestigen",
    "detail.booking": "Reserveren...",
    "detail.connectToBook": "Log in om te reserveren!",
    "detail.invalidPlaces": "Ongeldig aantal plaatsen.",
    "detail.modify": "Wijzigen",
    "detail.spectatorReviews": "Recensies van toeschouwers",
    "detail.places": "plaatsen",

    "comments.translateTo": "Recensies vertalen naar:",
    "comments.review": "recensie",
    "comments.edit": "Mijn recensie wijzigen",
    "comments.leave": "Een recensie achterlaten",
    "comments.connectToComment": "Inloggen om te becommentariëren",
    "comments.yourRating": "Uw score",
    "comments.yourReview": "Uw recensie",
    "comments.shareExp": "Deel uw ervaring...",
    "comments.publish": "Publiceren",
    "comments.update": "Bijwerken",
    "comments.sending": "Versturen...",
    "comments.empty": "Nog geen recensies. Wees de eerste!",
    "comments.modified": "(gewijzigd)",
    "comments.delete": "Verwijderen",
    "comments.deleteConfirm": "Dit commentaar verwijderen?",
    "comments.translate": "Vertalen",
    "comments.translating": "Vertalen...",
    "comments.hide": "Vertaling verbergen",
    "comments.translation": "Vertaling",
    "comments.detected": "gedetecteerd",
    "comments.via": "via",
    "comments.contentRequired": "Het commentaar mag niet leeg zijn.",

    "reservations.title": "Mijn Reserveringen",
    "reservations.subtitle": "Bekijk uw reserveringen",
    "reservations.empty": "U heeft geen reserveringen.",
    "reservations.spectacle": "Voorstelling",
    "reservations.date": "Datum",
    "reservations.places": "Plaatsen",
    "reservations.status": "Status",
    "reservations.actions": "Acties",
    "reservations.pay": "Betalen",
    "reservations.cancel": "Annuleren",
    "reservations.cancelConfirm": "Deze reservering annuleren?",
    "reservations.statusCreated": "In afwachting van betaling",
    "reservations.statusConfirmed": "Bevestigd",
    "reservations.statusCancelled": "Geannuleerd",

    "payment.title": "Betaling",
    "payment.summary": "Bestelling overzicht",
    "payment.spectacle": "Voorstelling",
    "payment.totalToPay": "Totaal te betalen",
    "payment.stripeInfo": "U wordt doorgestuurd naar Stripe",
    "payment.stripeDesc": "Op de volgende pagina kunt u uw betaalmethode kiezen (bankkaart, Bancontact, iDEAL, enz.) afhankelijk van wat beschikbaar is in uw regio.",
    "payment.payWith": "Betaal {amount} EUR met Stripe",
    "payment.redirecting": "Doorverwijzen naar Stripe...",
    "payment.cancel": "Annuleren",
    "payment.preparing": "Betaling voorbereiden...",
    "payment.testMode": "Stripe testmodus",
    "payment.testCard": "Kaart",
    "payment.otherMethods": "Andere methoden (Bancontact, iDEAL, enz.): selecteer en klik op Betalen.",
    "payment.urlMissing": "Betaalpagina ontbreekt. Herlaad de pagina.",
    "payment.choose": "Kies uw betaalmethode",
    "payment.cannotLoad": "Kan betaling niet laden: ",

    "paySuccess.titleLoading": "Bevestigen...",
    "paySuccess.titleError": "Betaalfout",
    "paySuccess.titleSuccess": "Betaling bevestigd",
    "paySuccess.subtitle": "Bedankt voor uw reservering",
    "paySuccess.verifying": "Betaling verifiëren...",
    "paySuccess.verifyingDesc": "Wij valideren uw transactie met Stripe.",
    "paySuccess.errorTitle": "Bevestigingsfout",
    "paySuccess.successTitle": "Betaling geslaagd!",
    "paySuccess.successDesc": "Uw reservering is bevestigd.",
    "paySuccess.paidWith": "Betaald via",
    "paySuccess.receiptSent": "Een ontvangstbewijs is naar uw e-mail gestuurd.",
    "paySuccess.myReservations": "Mijn reserveringen",
    "paySuccess.home": "Home",
    "paySuccess.sessionMissing": "Stripe sessie-ID ontbreekt.",
    "paySuccess.confirmFailed": "Bevestiging mislukt.",

    "payCancel.title": "Betaling geannuleerd",
    "payCancel.subtitle": "Er is geen bedrag afgeschreven",
    "payCancel.message": "U heeft de transactie geannuleerd. Er is geen bedrag afgeschreven.",
    "payCancel.bookingPending": "Uw reservering blijft in afwachting. U kunt de betaling op elk moment hervatten.",
    "payCancel.retry": "Betaling opnieuw proberen",
    "payCancel.myReservations": "Mijn reserveringen",

    "cookie.title": "Privacy melding",
    "cookie.text": "Wij gebruiken essentiële technische cookies voor de werking van de site (sessie, authenticatie) en, met uw toestemming, publiekmeting cookies.",
    "cookie.learnMore": "Meer info",
    "cookie.reject": "Weigeren",
    "cookie.accept": "Alles accepteren",

    "legal.title": "Juridische kennisgeving & Privacy",
    "legal.subtitle": "Uw rechten en onze verplichtingen",
    "legal.legalNotice": "Juridische kennisgeving",
    "legal.editor": "Site uitgever",
    "legal.editorDesc": "PID Réservations — Academisch project voor de cursus Geïntegreerd Project (ICC).",
    "legal.contact": "Contact",
    "legal.hosting": "Hosting",
    "legal.hostingDesc": "Gehost op een Hetzner Cloud VPS (Ubuntu 24.04, Helsinki) — Docker containers (nginx + Spring Boot + MySQL) — HTTPS via Let's Encrypt — Domein artistdb-icc.duckdns.org.",
    "legal.tech": "Technologieën",
    "legal.techDesc": "React 19, Spring Boot 3, MySQL, Stripe (betalingen), Mailtrap (test e-mails).",
    "legal.privacy": "Privacy beleid (GDPR)",
    "legal.dataCollected": "Verzamelde gegevens",
    "legal.dataCollectedDesc": "Bij registratie verzamelen wij: uw voornaam, achternaam, e-mail en wachtwoord (gehasht opgeslagen met BCrypt). Bij reservering bewaren wij de geschiedenis van uw aankopen zodat u ze kunt raadplegen in uw persoonlijke ruimte.",
    "legal.purpose": "Doel",
    "legal.purposeDesc": "Uw gegevens worden uitsluitend gebruikt om de reserveringsdienst te leveren: authenticatie, ticketaankoop, bevestigings- en reset e-mails. Geen gegevens worden aan derden verkocht.",
    "legal.retention": "Bewaartermijn",
    "legal.retentionDesc": "Uw gegevens worden bewaard zolang uw account actief is. Bij verwijdering van uw account worden uw persoonsgegevens binnen 30 dagen gewist (historische reserveringen worden geanonimiseerd voor de boekhouding).",
    "legal.rights": "Uw rechten",
    "legal.rightsDesc": "Onder de GDPR heeft u recht op toegang, rectificatie, verwijdering en overdraagbaarheid van uw gegevens. Om deze rechten uit te oefenen, contacteer ons op",
    "legal.cookies": "Cookies",
    "legal.cookiesYourChoice": "Uw huidige keuze",
    "legal.cookiesOptional": "Optionele cookies",
    "legal.cookiesAccepted": "Geaccepteerd",
    "legal.cookiesRejected": "Geweigerd",
    "legal.cookiesNotChosen": "Niet gekozen",
    "legal.cookiesAccept": "Accepteren",
    "legal.cookiesReject": "Weigeren",
    "legal.cookiesReset": "Resetten",
    "legal.cookiesTechnical": "Technische cookies (verplicht)",
    "legal.cookiesTechnicalDesc": "De site gebruikt localStorage om uw JWT token (login sessie) en uw gebruikersprofiel (voornaam, achternaam, rol) te bewaren. Deze gegevens zijn essentieel voor de werking en vereisen geen toestemming.",
    "legal.cookiesOptionalDesc": "Er worden momenteel geen tracking cookies van derden gebruikt (Google Analytics, Facebook Pixel, enz.). De toestemmingsbanner laat u toe deze cookies te accepteren of weigeren als wij ze in de toekomst toevoegen.",
    "legal.payments": "Beveiligde betalingen",
    "legal.paymentsDesc": "Betalingen worden verwerkt door Stripe. Geen bankgegevens worden op onze servers opgeslagen: het kaartnummer wordt rechtstreeks ingevoerd in een beveiligd formulier gehost door Stripe (PCI-DSS standaard).",
  },
};

export const SUPPORTED_LANGUAGES = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
];

export default translations;
